"use client";
import React, { useEffect, useState } from "react";
import Location from "./Location";
import { ENDPOINTS } from "@/constants/endpoint";

export default function VenueLocationSection({ data, params, cmsEntry }) {
  const [locationData, setLocationData] = useState(null);
  const [venue, setVenue] = useState(cmsEntry?.entity_data || null);

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      const resolvedParams =
        params && typeof params.then === "function" ? await params : params;
      const rawSlug = resolvedParams?.slug;
      const slug = Array.isArray(rawSlug)
        ? rawSlug[rawSlug.length - 1]
        : rawSlug ||
          cmsEntry?.entity_data?.google_place_id ||
          cmsEntry?.entity_data?.address?.google_place_id ||
          cmsEntry?.entity_data?.slug ||
          (typeof cmsEntry?.slug === "string" &&
          cmsEntry.slug.startsWith("venue/")
            ? cmsEntry.slug.replace(/^venue\//, "")
            : cmsEntry?.slug);

      if (!slug) return;

      try {
        const placeRes = await fetch(`/api/place?place_id=${slug}`);
        if (placeRes.ok) {
          const json = await placeRes.json();
          if (isMounted && json && !json.error) setLocationData(json);
        }
      } catch (e) {
        console.warn("Location section place fetch failed", e);
      }

      if (!cmsEntry?.entity_data) {
        try {
          const venueUrl = `${process.env.NEXT_PUBLIC_API_URL}/${ENDPOINTS.VENUE_DETAILS.replace(":slug", slug)}`;
          const venueRes = await fetch(venueUrl, {
            headers: {
              "Content-Type": "application/json",
              "X-Server-Secret":
                "H4KxWTUuPXWyhkxCq0AThQzDVrg7wRkIVeAuFim6uZJQJWDqvA8KWYKxqxhPejgY",
            },
          });
          if (venueRes.ok) {
            const json = await venueRes.json();
            if (isMounted && json?.data) setVenue(json.data);
          }
        } catch (e) {
          console.warn("Location section venue fetch failed", e);
        }
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [params, cmsEntry]);

  if (data?.section_status && data.section_status !== "active") return null;
  if (data?.status === false) return null;
  if (
    data?.enable_map === false ||
    data?.show_map === false ||
    data?.enable_location === false ||
    data?.show_location === false
  ) {
    return null;
  }

  if (!locationData && !venue) return null;
  return (
    <div
      className="container !px-4 md:px-0 py-6"
      style={{
        color: "#171717",
        fontFamily: "Bricolage Grotesque",
      }}
    >
      <Location locationData={locationData} venue={venue} title={data?.title} />
    </div>
  );
}
